<template>
  <div class="manage">
    <div class="manage__header">
      <div class="manage__header__bread" @click="toSchedules">
        <i class="adx-ic_chevron_left"></i>
        <p>Schedules</p>
      </div>
      <div class="manage__header__title">
        <h2>Content Management</h2>
      </div>
    </div>
    <adx-empty-selection v-if="isEmpty && !isLoading" />
    <div v-else class="manage__content">
      <div class="manage__content__left">
        <div class="manage__content__left__filter">
          <div class="manage__content__left__filter__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
          <div class="manage__content__left__filter__buttons">
            <div class="manage__content__left__filter__buttons__city">
              <adx-dropdown-list 
                :labelButton="selectedCity.label?selectedCity.label:'All City'" 
                :list="cityList"
                @selected="selectCity" />
            </div>
            <div class="manage__content__left__filter__buttons__orientation">
              <adx-dropdown-list 
                :labelButton="selectedOrientation.label?selectedOrientation.label:'All Orientation'" 
                :list="orientationList"
                @selected="selectOrientation" />
            </div>
          </div>
        </div>
        <adx-loading v-if="isLoading" />
        <div v-else class="manage__content__left__device">
          <div class="manage__content__left__device--top">
            <span class="manage__content__left__device__title">DEVICES</span>
          </div>
          <div class="manage__content__left__device--bot">
            <div v-for="item in filteredDevices" :key="item.id" class="manage__content__left__device__item"
            :class="selectedDevice == item.id ? 'selected' : ''" @click="selectDevice(item.id)">
              <div class="manage__content__left__device__item__photo">
                <img v-if="item.orientation == 'Portrait'" class="portrait" :src="`/img/notfound/tv_portrait.png`" alt="">
                <img v-else class="landscpae" :src="`/img/notfound/tv_land.png`" alt="">
              </div>
              <div class="manage__content__left__device__item__desc">
                <span class="bold">{{item.location_name}}</span>
                <span class="bold">{{item.city_name}}</span>
                <span class="light">{{item.placement}}</span>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <div class="manage__content__right">
        <div class="manage__content__right__media">
          <div class="manage__content__right__media__header">
            <span class="manage__content__right__media__header__title">Media Playlist</span>
            <p>Move up and down content below</p>
          </div>
          <adx-loading v-if="isLoadingContent" />
          <adx-empty-selection v-else-if="isEmptyContent && !isLoadingContent" />
          <div v-else class="manage__content__right__media__content">
            <draggable v-model="listScheduleByDevice" @start="drag=true; messageSaved = ''" @end="drag=false">
              <div v-for="(schedule, index) in listScheduleByDevice" :key="index" 
                class="manage__content__right__media__content__drag">
                <div class="manage__content__right__media__content__drag__info">
                  <div class="manage__content__right__media__content__drag__info--picture" :style="contentThumbImage(schedule.content.thumb)"></div>
                  <div class="manage__content__right__media__content__drag__info--detail">
                    <div class="manage__content__right__media__content__drag__info--top">
                      <span class="manage__content__right__media__content__drag__info--name">
                        {{ schedule.content.title }}
                      </span>
                      <p> {{ getPeriod(schedule.start, schedule.end) }} </p>
                    </div>
                    <div class="manage__content__right__media__content__drag__info--bot">
                      <span class="manage__content__right__media__content__drag__info--duration">
                        {{ getDuration(schedule.duration) }}
                      </span>
                      <span v-if="schedule.is_self_owned" class="manage__content__right__media__content__drag__info--type">
                        &bull; Self Owned
                      </span>
                      <span v-else-if="schedule.is_sponsored" class="manage__content__right__media__content__drag__info--type">
                        &bull; Sponsored
                      </span>
                      <span v-else class="manage__content__right__media__content__drag__info--type">
                        &bull; Commercial
                      </span>
                    </div>
                  </div>
                </div>
                <span class="manage__content__right__media__content__drag__icon">
                  <i class="adx-ic_reorder"></i>
                </span>
              </div>
            </draggable>
          </div>
        </div>
        <div v-if="!isEmptyContent" class="manage__content__right__buttons">
          <button class="btn-block primary" :class="isSaveLoading ? 'load' : ''" @click="savePosition">
            Save & Publish 
            <div class="loading-wrap"> <adx-loading-white v-if="isSaveLoading" /> </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Loading from '@/components/Loading/Primary'
import LoadingWhite from '@/components/Loading/Secondary-white'
import draggable from 'vuedraggable';
import EmptySelection from '@/components/NotFound/Selection'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment'
const {
  helpers,
  validate
} = validationLib


export default {
  name: 'adx-schedules-manage',
  components: {
    'adx-dropdown-list': ListDropdown,
    'adx-loading': Loading,
    'adx-loading-white': LoadingWhite,
    'adx-empty-selection': EmptySelection,
    draggable
  },
  props: {

  },
  data() {
    return {
      isEmpty: false,
      isEmptyContent: true,
      isLoading: false,
      isLoadingContent: false,
      isSaveLoading: false,
      searchBoxValue: '',
      selectedCity: 
        {
          'id': 0,
          'label': 'All City',
          'value': ''
        },
      cityList: [
        {
          'id': 0,
          'label': 'All City',
          'value': ''
        },
      ],
      selectedOrientation: 
        {
          id: 0,
          label: 'All Orientation',
          value: ''
        },
      orientationList: [
        {
          id: 0,
          label: 'All Orientation',
          value: ''
        },
        {
          id: 1,
          label: 'Landscape',
          value: 'Landscape'
        },
        {
          id: 2,
          label: 'Portrait',
          value: 'Portrait'
        },
      ],
      selectedDevice: 0,
      devices: [],
      filteredDevices: [],
      listPlayingSchedule: [],
      listScheduleByDevice: [],
      messageSaved: "",
    }
  },
  computed: {

  },
  watch: {
    searchBoxValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.filterDevice()
      }
    },
    selectedOrientation: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.filterDevice()
      }
    },
    selectedCity: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.filterDevice()
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.getDevices()
    this.getCities()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    filterDevice() {
      let arrays = this.devices
      if (this.selectedCity.value) {
        arrays = arrays.filter(device => {
          return device.city_name == this.selectedCity.value
        })
      }
      if (this.selectedOrientation.value) {
        arrays = arrays.filter(device => {
          return device.orientation == this.selectedOrientation.value
        })
      }
      if(this.searchBoxValue) {
        arrays = arrays.filter(device => {
          let searchName = device.location_name.toLowerCase()
          let searchValue = this.searchBoxValue.toLowerCase()
          if (searchName.includes(searchValue)) return device
        })
      }
      this.filteredDevices = arrays
    },
    toSchedules() {
      this.$router.push({name:'hostschedules'})
    },
    selectCity(item){
      this.selectedCity = item
    },
    selectOrientation(item){
      this.selectedOrientation = item
    },
    selectDevice(id) {
      this.isLoadingContent = true
      this.messageSaved = ""
      this.selectedDevice = id
      this.displayContentsDevice()
    },
    getDevices(){
      (async () => {
        this.isLoading = true
        let params = {
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.dashboardHostDevices, { needToken: true, params })
        this.devices = data
        this.filteredDevices = data
        if (data.length > 0) {
          this.selectedDevice = data[0].id
        } else {
          this.isEmpty = true
        }
        this.isLoading = false
      })();
    },
    getCities(){
      (async () => {
        this.isLoading = true
        let params = {}
        const { data } = await api.get(apiV2.dashboardHostCities, { needToken: true, params })
        data.map(city => {
          this.cityList.push(
            {
              'id': city.id,
              'label': city.name,
              'value': city.name
            }
          )
        })
        this.isLoading = false
      })();
    },
    getContents() {
      (async () => {
        this.isLoadingContent = true
        let params = {}
        const response = await api.get(apiV2.dashboardHostSchedulesPlaying(this.selectedDevice), { needToken: true, params })
        if (response.status == 200) {
          this.listScheduleByDevice = response.data;

          for (var i = 0; i < this.listScheduleByDevice.length; i++) {
            this.listPlayingSchedule.push(this.listScheduleByDevice[i]);
          }
          
          if (this.listScheduleByDevice.length > 0) {
            this.isEmptyContent = false
          } else {
            this.isEmptyContent = true
          }
          this.isLoadingContent = false
        } else {
          this.listScheduleByDevice = []
        }
      })();
    },
    displayContentsDevice() {
      if (this.selectedDevice != 0) {
        var include = false

        for (var i = 0; i < this.listPlayingSchedule.length; i++) {
          if (this.listPlayingSchedule[i].device == this.selectedDevice) {
            include = true;
            break;
          }
        }

        if (include) {
          this.listScheduleByDevice = this.listPlayingSchedule.filter((schedule) => {
            if (schedule.device == this.selectedDevice) {
              return schedule
            }
          });
          if (this.listScheduleByDevice.length > 0) {
            this.isEmptyContent = false
          } else {
            this.isEmptyContent = true
          }
          this.isLoadingContent = false
        } else {
          this.getContents()
        }
      }
    },
    getDuration(duration) {
      let second = 0;
      let minute = 0;
      if (duration < 60) {
        second = duration;
        return `${second} s`;
      }
      else if (duration >= 60 && duration < 3600) {
        let minute = Math.floor(duration/60);
        let second = duration - (minute * 60);
        return `${minute} m ${second} s`;
      } 
    },
    getPeriod(start, end) {
      let startFormatted = moment(start.split("-").reverse().join("-"), "DD-MM-YYYY");
      let endFormatted = moment(end.split("-").reverse().join("-"), "DD-MM-YYYY");
      return `${startFormatted.format(`DD MMM YYYY`)} - ${endFormatted.format(`DD MMM YYYY`)}`;
    },
    contentThumbImage(url) {
      return `background-image: url('${url}')`;
    },
    savePosition() {
      this.isSaveLoading = true
      let length = 0
      this.messageSaved = ""
      let schedule_param = []
      this.listScheduleByDevice.map((schedule, index) => {
        length = index + 1
        if (schedule.order !== index) {
          schedule_param.push({'id':schedule.id, 'position':length})
        }
      });
      this.isSaveLoading = false
      if (schedule_param.length > 0){
        (async () => {
          this.isSaveLoading = true
          let data = {
            "data": schedule_param
          }
          let response = await api.patch(apiV2.dashboardHostSchedulesPosition, data, { needToken: true })
          if (response.status == 200) {
            this.messageSaved = "Position Saved"
            this.$notify({
              group: 'saved',
              title: 'Position updated',
              text: 'Content position successfully updated',
              type: 'success'
            });
            // this.getContents()
            schedule_param.map((newValue, index) => {
              this.listPlayingSchedule.map((oldValue, ind) => {
                if (newValue.id == oldValue.id) {
                  oldValue.order = newValue.position - 1
                }
              });
            });
            this.listPlayingSchedule = this.listPlayingSchedule.sort((a, b) => {
              return parseInt(a.order) - parseInt(b.order)
            })
          } else {
            this.messageSaved = response.data.message
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'sorry something went wrong!',
              type: 'danger'
            });
          }
          this.isSaveLoading = false
        })();
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang="scss">
  .manage__content__left__filter__buttons__orientation,
  .manage__content__left__filter__buttons__city{
    .dropdown .dropdown__menu {
      min-width: 160px;
    }
  }
</style>
